// 渲染配置化的文本，主要处理换行
import { LANGUAGE_EN } from '@home/_config/config';
import { getName } from '@home/utils/common';
import React from 'react';
import { useIntl } from 'umi';

interface IProps {
  contentEn: string;
  contentCn: string;
}
const RenderConfigText = (props: IProps) => {
  const { contentEn, contentCn } = props;
  const { locale } =  useIntl();
  
  const renderText = getName(locale === LANGUAGE_EN, contentEn || '', contentCn || '')
    .split('\\n')
    .map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));

  return renderText;
};

export default RenderConfigText;